import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PoliticaPrivacidad = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
            Política de Privacidad
          </h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <p className="text-sm text-muted-foreground">
              Última actualización: Enero 2026
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                1. Responsable del tratamiento
              </h2>
              <p>
                En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo 
                (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales 
                y garantía de los derechos digitales (LOPDGDD), le informamos de que:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Responsable:</strong> HABITUSPAY ESPAÑA SL</li>
                <li><strong>CIF:</strong> B24795155</li>
                <li><strong>Domicilio:</strong> Calle La Palma, 1 - Ptl 6, Piso 1 D, 28850 Torrejón de Ardoz, Madrid, España</li>
                <li><strong>Correo electrónico:</strong> soporte@habituspay.com</li>
                <li><strong>Delegado de Protección de Datos (DPO):</strong> soporte@habituspay.com</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                2. Datos personales que tratamos
              </h2>
              <p>
                Dependiendo de los servicios que utilice, podemos tratar las siguientes categorías 
                de datos personales:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Datos identificativos:</strong> nombre, apellidos, DNI/NIE, cargo en la empresa.</li>
                <li><strong>Datos de contacto:</strong> dirección de correo electrónico, teléfono.</li>
                <li><strong>Datos profesionales:</strong> empresa, puesto de trabajo, departamento.</li>
                <li><strong>Datos de uso:</strong> información sobre cómo utiliza nuestra plataforma, 
                    dirección IP, tipo de navegador, páginas visitadas.</li>
                <li><strong>Datos financieros:</strong> información de transacciones gestionadas 
                    a través de la plataforma (siempre en el contexto de la relación B2B con su empresa).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                3. Finalidad del tratamiento
              </h2>
              <p>
                Tratamos sus datos personales para las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Prestación de servicios:</strong> gestionar su cuenta de usuario y 
                    proporcionar acceso a la plataforma HabitusPay.</li>
                <li><strong>Gestión de la relación contractual:</strong> facturación, atención 
                    al cliente y soporte técnico.</li>
                <li><strong>Comunicaciones comerciales:</strong> envío de información sobre 
                    productos y servicios (previo consentimiento).</li>
                <li><strong>Mejora del servicio:</strong> análisis de uso para mejorar la 
                    experiencia de usuario y funcionalidades.</li>
                <li><strong>Cumplimiento legal:</strong> cumplir con obligaciones legales, 
                    fiscales y contables.</li>
                <li><strong>Seguridad:</strong> prevención del fraude y protección de la 
                    seguridad de la plataforma.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                4. Base legal del tratamiento
              </h2>
              <p>
                El tratamiento de sus datos se fundamenta en las siguientes bases legales:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Ejecución de contrato:</strong> el tratamiento es necesario para 
                    la prestación de los servicios contratados (Art. 6.1.b RGPD).</li>
                <li><strong>Consentimiento:</strong> para el envío de comunicaciones comerciales 
                    (Art. 6.1.a RGPD).</li>
                <li><strong>Interés legítimo:</strong> para la mejora de nuestros servicios y 
                    la prevención del fraude (Art. 6.1.f RGPD).</li>
                <li><strong>Obligación legal:</strong> para el cumplimiento de obligaciones 
                    fiscales y contables (Art. 6.1.c RGPD).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                5. Destinatarios de los datos
              </h2>
              <p>
                Sus datos podrán ser comunicados a los siguientes destinatarios:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Proveedores de servicios de tarjetas:</strong> como Wallester AS 
                    (entidad de dinero electrónico autorizada), para la emisión y gestión de 
                    tarjetas empresariales.</li>
                <li><strong>Proveedores de servicios tecnológicos:</strong> empresas que nos 
                    ayudan a proporcionar nuestros servicios (alojamiento, análisis, etc.).</li>
                <li><strong>Administraciones públicas:</strong> cuando así lo exija la normativa 
                    aplicable.</li>
                <li><strong>Asesores profesionales:</strong> abogados, auditores y consultores 
                    bajo obligación de confidencialidad.</li>
              </ul>
              <p className="mt-4">
                No realizamos transferencias internacionales de datos fuera del Espacio Económico 
                Europeo (EEE) sin las garantías adecuadas establecidas en el RGPD.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                6. Plazos de conservación
              </h2>
              <p>
                Conservaremos sus datos personales durante el tiempo necesario para cumplir con 
                las finalidades para las que fueron recabados:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Datos de clientes:</strong> durante la vigencia de la relación 
                    contractual y posteriormente durante el plazo de prescripción de acciones 
                    legales (5 años).</li>
                <li><strong>Datos fiscales:</strong> 4 años según la normativa tributaria.</li>
                <li><strong>Datos de navegación:</strong> máximo 24 meses.</li>
                <li><strong>Comunicaciones comerciales:</strong> hasta que retire su consentimiento.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                7. Derechos del interesado
              </h2>
              <p>
                Como titular de los datos, tiene derecho a:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Acceso:</strong> conocer qué datos personales tratamos sobre usted.</li>
                <li><strong>Rectificación:</strong> solicitar la corrección de datos inexactos.</li>
                <li><strong>Supresión:</strong> solicitar la eliminación de sus datos cuando ya 
                    no sean necesarios.</li>
                <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos en 
                    determinadas circunstancias.</li>
                <li><strong>Limitación:</strong> solicitar la limitación del tratamiento en 
                    ciertos casos.</li>
                <li><strong>Portabilidad:</strong> recibir sus datos en formato estructurado 
                    y transmitirlos a otro responsable.</li>
                <li><strong>Retirada del consentimiento:</strong> en cualquier momento, sin 
                    que afecte a la licitud del tratamiento previo.</li>
              </ul>
              <p className="mt-4">
                Para ejercer estos derechos, puede contactar con nosotros en: 
                <a href="mailto:soporte@habituspay.com" className="text-accent hover:underline">
                  soporte@habituspay.com
                </a>
              </p>
              <p className="mt-4">
                También tiene derecho a presentar una reclamación ante la Agencia Española de 
                Protección de Datos (AEPD) en <a href="https://www.aepd.es" target="_blank" 
                rel="noopener noreferrer" className="text-accent hover:underline">www.aepd.es</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                8. Medidas de seguridad
              </h2>
              <p>
                Hemos implementado medidas técnicas y organizativas adecuadas para proteger sus 
                datos personales contra el acceso no autorizado, la pérdida, la destrucción o 
                el daño accidental, incluyendo:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Cifrado de datos en tránsito y en reposo.</li>
                <li>Control de acceso basado en roles.</li>
                <li>Monitorización y auditoría de sistemas.</li>
                <li>Formación continua del personal en protección de datos.</li>
                <li>Políticas de seguridad de la información.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                9. Modificaciones de la política
              </h2>
              <p>
                Nos reservamos el derecho a modificar esta Política de Privacidad para adaptarla 
                a novedades legislativas o jurisprudenciales. Cualquier cambio significativo será 
                comunicado a través de nuestra plataforma o por correo electrónico.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                10. Contacto
              </h2>
              <p>
                Para cualquier consulta relacionada con el tratamiento de sus datos personales, 
                puede contactar con nosotros:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Correo electrónico: <a href="mailto:soporte@habituspay.com" 
                    className="text-accent hover:underline">soporte@habituspay.com</a></li>
                <li>Delegado de Protección de Datos: <a href="mailto:soporte@habituspay.com" 
                    className="text-accent hover:underline">soporte@habituspay.com</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaPrivacidad;
